import React from 'react';
import styled from 'styled-components';
import DataCollectionInformation from './DataCollectionInformation';

const StyledFooter = styled.footer`
  width: 100%;
  margin-top: auto;
  padding: 1rem 0;
  background: #f9f9f9;
  display: flex;
  justify-content: center;
`;

const Footer = () => (
  <StyledFooter>
    <DataCollectionInformation />
  </StyledFooter>
);

export default Footer;